import { Tag, Tooltip } from "antd";

export type TagItem = { tag: string; value: string };

function LimitedTags({
  tags,
  maxVisible = 3,
  reportId
}: {
  reportId: string;
  tags: TagItem[];
  maxVisible?: number;
}) {
  if (!tags || tags.length === 0) return null;

  const visibleTags = tags.slice(0, maxVisible);
  const hiddenTags = tags.slice(maxVisible);

  return (
    <div
      className="flex flex-wrap gap-y-1.5"
      data-testid={`limited-tags-${reportId}`}
    >
      {visibleTags.map((tag) => (
        <Tag
          key={`tag-${tag.value}-${reportId}`}
          className="text-black text-opacity-90"
          data-testid={`limited-tag-${tag.value}-${reportId}`}
        >
          {tag.tag}
        </Tag>
      ))}

      {hiddenTags.length > 0 && (
        <Tooltip
          title={
            <div className="flex flex-col gap-1">
              {hiddenTags.map((tag) => (
                <Tag
                  key={`hidden-${tag.value}-${reportId}`}
                  className="text-xs text-black text-opacity-90 truncate"
                >
                  {tag.tag}
                </Tag>
              ))}
            </div>
          }
        >
          <Tag
            className="text-xs text-black text-opacity-90 cursor-pointer flex items-center"
            data-testid={`limited-tags-hidden-count-${reportId}`}
          >
            +{hiddenTags.length}
          </Tag>
        </Tooltip>
      )}
    </div>
  );
}

export default LimitedTags;
